module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('op-stats', {
    attrs: {
      "show-requests": false
    }
  }), _vm._v(" "), _c('ticket-summary'), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "tickets"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Maintenance Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a705b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/MaintenanceSummary.vue
// module id = 1504
// module chunks = 0